import {Buffer} from 'buffer';

const Frame= () : Buffer => {
    return Buffer.alloc(9);
}
export default Frame;